module.exports = __webpack_public_path__ + "img/2025big16.99683be0.jpg";